import { CentralizedSliderBase } from "@reusejs/react";
import LeftArrowSvg from "../../Icons/LeftArrowSvg";
import RightArrowSvg from "../../Icons/RightArrowSvg";
import { ChevronRightIcon, ChevronLeftIcon } from "@heroicons/react/solid";

export interface ImageSliderComponentProps {
  elements: React.ReactNode[];
}

export function ImageSliderComponent(props: ImageSliderComponentProps) {
  const LeftArrow = (props: any) => {
    return (
      <div
        className="absolute cursor-pointer top-1/2 left-0 flex justify-start z-9 transform rounded-full -translate-y-1/2 mx-3 bg-white hover:bg-gray-100 hover:text-blue-700"
        onClick={() => {
          props.swiperRef.current.slidePrev();
        }}
      >
        <div className="hidden md:block">
          <ChevronLeftIcon height="36" width="36" />
        </div>
        <div className="block md:hidden">
          <ChevronLeftIcon height="18" width="18" />
        </div>
      </div>
    );
  };

  const RightArrow = (props: any) => {
    return (
      <div
        className="absolute cursor-pointer top-1/2 right-0 flex justify-end z-9 transform rounded-full -translate-y-1/2 mx-3 bg-white hover:bg-gray-100 hover:text-blue-700"
        onClick={() => {
          props.swiperRef.current.slideNext();
        }}
      >
        <div className="hidden md:block ">
          <ChevronRightIcon height="36" width="36" />
        </div>
        <div className="block md:hidden ">
          <ChevronRightIcon height="18" width="18" />
        </div>
      </div>
    );
  };

  return (
    <div className="w-full md:max-w-screen-xl">
      <CentralizedSliderBase
        gap={20}
        slidesPerView={1}
        centeredSlides={true}
        loop={true}
        renderArrowLeft={LeftArrow}
        renderArrowRight={RightArrow}
        autoPlay={5000}
      >
        {props.elements}
      </CentralizedSliderBase>
    </div>
  );
}
